<template>
    <b-modal :visible="true"
             size="md"
             hide-header
             @hidden="$emit('close')">
        <div class="text-center p-3">
            <font-awesome-icon v-if="showReservationMessage"
                               :icon="icons.faHourglassClock"
                               class="text-info mb-3"
                               size="3x" />
            <font-awesome-icon v-else
                               :icon="icons.faCheckCircle"
                               class="text-success mb-3"
                               size="3x" />
            <h4 v-if="showReservationMessage">
                {{ $t(`cart.${options.message_type}`) }}
            </h4>
            <h4 v-else>
                {{ showIncassoWarning ? $t('cart.item_added_successfully_incasso') : $t('cart.item_added_successfully') }}
            </h4>
        </div>
        <template #modal-footer>
            <div class="d-flex w-100"
                 :class="{ 'justify-content-end': showReservationMessage, 'justify-content-between': !showReservationMessage }">
                <b-button variant="outline-secondary"
                          @click="closeModal">
                    {{ $t(showReservationMessage ? 'actions.close' :'cart.continue_shopping') }}
                </b-button>
                <b-button v-show="!showReservationMessage"
                          variant="primary"
                          @click="goToCart">
                    <font-awesome-icon v-show="!showIncassoWarning"
                                       :icon="icons.faShoppingCart"
                                       class="mr-2" />
                    {{ showIncassoWarning ? $t('cart.go_to_cart_incasso') : $t('cart.go_to_cart') }}
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCheckCircle, faShoppingCart, faHourglassClock } from '@fortawesome/pro-solid-svg-icons'
import { refreshCartData } from './index'

export default {
  name: 'AddToCartModal',

  components: {
    FontAwesomeIcon
  },

  props: {
    showIncassoWarning: {
      type: Boolean,
      default: false
    },
    showReservationMessage: Boolean,
    options: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      icons: {
        faCheckCircle,
        faShoppingCart,
        faHourglassClock
      }
    }
  },

  mounted () {
    refreshCartData()
  },

  methods: {
    goToCart () {
      window.location.href = (window.cartUrl || '/bestellen/winkelwagen') + (this.showIncassoWarning ? '?process=incasso' : '')
    },

    closeModal () {
      // Remove the hash without triggering another hashchange
      history.replaceState(null, '', window.location.pathname + window.location.search)
      this.$emit('close')
    }
  }
}
</script>

<style>
.cart-badge-bounce {
  animation: cartBadgeBounce 0.3s ease-in-out;
}

@keyframes cartBadgeBounce {
  0% {
    transform: scale(0.85);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1);
  }
}
</style>
